import Banana from 'banana-i18n';

const banana = new Banana();
const messages = {
  'en': {
    'toast-info-title': 'Info',
    'toast-warning-title': 'Warning'
  },
  'it' : {
    'toast-info-title': 'Info',
    'toast-warning-title': 'Attenzione'
  }
};
banana.load(messages); // Note that the locale parameter is missing here
banana.setLocale('en');
window.banana = banana;
